<script setup lang="ts">

import {CBreadcrumb, CBreadcrumbItem} from "@coreui/vue/dist/esm/components/breadcrumb";
const breadcrumbs = ref()
const router = useRouter()

function gerarSubRotas(fullPath: string): string[] {
  const parts = fullPath.split('/').filter(Boolean)
  let acc = ''
  return parts.map((part) => {
    acc += '/' + part
    return acc
  }).filter(rota => rota !== '')
}

function transformText(rota: string): string {
  const lastSegment = rota.split('/').filter(Boolean).pop() || ''
  return lastSegment.replace(/-/g, ' ').replace(/\b\w/g, l => l.toUpperCase()) || 'Início'
}

const getBreadcrumbs = () => {
  const inicio = [
    {
      active: false,
      name: 'Início',
      path: '/',
    }
  ]

  if (router.currentRoute.value.fullPath === '/') {
    return [...inicio]
  }

  let fullPath = router.currentRoute.value.fullPath

  if (fullPath.includes('?')) {
    fullPath = fullPath.split('?')[0]
  }

  if (fullPath[fullPath.length - 1] === '/') {
    fullPath = fullPath.slice(0, -1)
  }

  const originalPath = fullPath

  if (router.currentRoute.value.params) {
    for (const parametro in router.currentRoute.value.params) {
      const paramValue = router.currentRoute.value.params[parametro]
      if (paramValue) {
        fullPath = fullPath.replace(`/${paramValue}`, '')
      }
    }
  }

  if (!fullPath || fullPath === '/') {
    return [...inicio]
  }

  const subRotas = gerarSubRotas(fullPath)

  if (subRotas.length === 0) {
    return [...inicio]
  }

  const restante = subRotas.map((rota: string, index: number) => {
    const isLast = index === subRotas.length - 1
    return {
      active: isLast,
      name: transformText(rota),
      path: rota,
    }
  })

  return [...inicio, ...restante]
}

const navegarPara = (path: string) => {
  if (path && path !== '/') {
    navigateTo(path)
  } else {
    navigateTo('/')
  }
}

router.afterEach(() => {
  breadcrumbs.value = getBreadcrumbs()
})

onMounted(() => {
  breadcrumbs.value = getBreadcrumbs()
})

</script>

<template>

  <CBreadcrumb class="my-0">
    <CBreadcrumbItem 
      v-for="(item, index) in breadcrumbs" 
      :key="`breadcrumb-${index}-${item.path}`" 
      :active="item.active" 
      class="text-white"
      role="button"
      @click="!item.active && navegarPara(item.path)"
    >
      {{ item.name }}
    </CBreadcrumbItem>
  </CBreadcrumb>

</template>

<style>
a {
  color: white;
  text-decoration: none;
}

a:hover,
a:focus {
  text-decoration: underline;
}
</style>